/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featureon1Inputs */

const en_featureon1 = /** @type {(inputs: Featureon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on`)
};

const de_featureon1 = /** @type {(inputs: Featureon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an`)
};

/**
* | output |
* | --- |
* | "on" |
*
* @param {Featureon1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const featureon1 = /** @type {((inputs?: Featureon1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featureon1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featureon1(inputs)
	return de_featureon1(inputs)
});
export { featureon1 as "featureOn" }